import React from 'react'
import About from '../public/about/About'
import MenuDoctor from './navDoctor/MenuDoctor'

function AboutMedical() {
    return (
        <div>
            <MenuDoctor />
            <About disabledMenu />
        </div>
    )
}

export default AboutMedical